import { useState } from "react";
import { toast } from "react-toastify";
import { useLogout, useCurrentUser } from "utils/hooks";
import { AssignmentLink } from "types";

type Props = {
  assignmentId: string;
  visibleToPatient: boolean;
};

const useGenerateAssignmentLink = () => {
  const [loading, setLoading] = useState(false);
  const [generatedLink, setGeneratedLink] = useState<AssignmentLink | null>(
    null
  );
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const generateAssignmentLink = ({
    assignmentId,
    visibleToPatient,
  }: Props) => {
    if (!assignmentId) return toast.error("Error");

    setLoading(true);

    const args = { assignmentId, visibleToPatient };
    try {
      return new Promise(() => {
        fetch(
          `${process.env.REACT_APP_REST_API_URL}/p/assignment/generate-link`,
          {
            method: "POST",
            credentials: "include",
            body: JSON.stringify({ args }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              organizationId: user?.activeOrganizationId || "NA",
              permissionKey: "create_links",
            },
          }
        )
          .then(async (res) => {
            if (res.status !== 201) {
              const error = await res.json();
              if (
                error?.message.includes("BRKN_6001") ||
                error?.message.includes("GGST_6002") ||
                error?.message.includes("BRKN_6007")
              ) {
                toast.warn("For security purposes please log in again.");
                logOut();
              } else {
                toast.error(
                  `${error?.message || "Hmm, something went wrong."}`
                );
                return false;
              }
            }
            return await res.json();
          })
          .then((resData) => {
            if (resData.link) setGeneratedLink(resData.link);
          })
          .finally(() => setLoading(false));
      });
    } catch (error) {
      console.log(error);
    }
  };

  return { generateAssignmentLink, generatedLink, loading };
};

export default useGenerateAssignmentLink;
